export default __webpack_public_path__ + "media/zurb/img/home/ebay-logo-d93563ab9382bbd908165376031d66ea.png";